import React, {useEffect, useState} from "react";
import "./Sections.css"
import {Grid} from "@material-ui/core";
import "./WorksSection.css";
import BoxEffect from "./BoxEffect";
import {SectionProps} from "./Section";
import {Works} from "../Data/Works";

const WorksSection:React.FC<SectionProps> = (props) => {
    const [selectId,setSelectId] = useState(0);
    const works= Works;
    return(
        <div className={"SectionBase Works"}>
            <div className={"SectionContent"}>
                <BoxEffect isActive={props.isActive} delay={0.0}>
                    <div className={"SectionTitle"}>
                        Independent Works
                    </div>
                </BoxEffect>
                <BoxEffect isActive={props.isActive} delay={0.125}>
                    <div className={"SectionSubtitle"}>
                        制作物（自主制作）
                    </div>
                </BoxEffect>
                <Grid container>
                    <Grid item xs={12} sm={3} className={"SectionWindowContainer"}>
                        <div className={"SectionMenuWindow"}>
                            {works.map((e,i) => {return(<WorksMenuBar onClick={() => {setSelectId(i)}} isActive={selectId == i} label={e.title}/>)})}
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={9} className={"SectionWindowContainer"}>
                        <div className={"SectionMainWindow"}>
                            <div className={"Padding10"}>
                                <div className={"SectionTitle"}>
                                    {works[selectId].title}
                                </div>
                                <hr className={"SectionHR"}/>
                                <div className={"SectionSubtitle"}>
                                    {works[selectId].subtitle}
                                </div>
                                <div className={"Padding10"}>
                                    {works[selectId].description}
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

interface WorksMenuBarProps{
    label:string;
    isActive:boolean;
    onClick:() => void;
}

const WorksMenuBar:React.FC<WorksMenuBarProps> = (props) => {
    const [isHovering,setIsHovering] = useState(false);
    const onEnter = () => {
        setIsHovering(true);
    }
    const onLeave = () => {
        setIsHovering(false);
    }
    return(
        <div className={"WorksMenuBar"} onMouseEnter={onEnter} onMouseLeave={onLeave} onClick={props.onClick}>
            <div className={"WorksMenuBarHoverEffect " + ((isHovering||props.isActive)?"Active":"InActive")}/>
            <div className={"WorksMenuContent"}>
                {props.label}
            </div>
        </div>
    );
};

export default WorksSection;